import {
  GET_TYPE_SETTING_EXITO,
  GET_TYPE_SETTING
} from '../types/typeSettingActionsTypes'
import { TypeSetting } from '../../interfaces/Settings/settings'

export type TypeSettingAction =
  | TypeSettingsAction
  | TypeSettingsActionAsync

// Esto va a REDUX
export interface TypeSettingsAction {
  type: typeof GET_TYPE_SETTING_EXITO
  typeSetting: TypeSetting[]
  error: string | undefined
}

export const getTypeSettingAction = (
  typeSetting: TypeSetting[],
  error?: string
): TypeSettingsAction => {
  return {
    type: GET_TYPE_SETTING_EXITO,
    typeSetting: typeSetting,
    error
  }
}

// Esto va a SAGA
export interface TypeSettingsActionAsync {
  type: typeof GET_TYPE_SETTING
}

export const getTypeSettingActionAsync = (): TypeSettingsActionAsync => {
  return {
    type: GET_TYPE_SETTING
  }
}
